module.exports = __webpack_public_path__ + "img/1_018.4ff75940.jpg";